import React from "react";
import Typography from "@mui/material/Typography";

export default function SubTitle({ children, fontWeight, color }) {
  return (
    <Typography
      component="h6"
      variant="h6"
      fontWeight={fontWeight}
      color={color}
    >
      {children}
    </Typography>
  );
}
